const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    height: "100%",
    padding: "30px 30px 35px",
    fontFamily: "Helvetica Neue",
    "@media (max-width: 767px)": {
      padding: "30px 25px",
    },
  },
  topSection: {
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    color: "#252528",
    "@media (max-width: 370px)": {
      fontSize: "14px",
    },
  },
  topText: {
    marginLeft: "30px",
    fontWeight: 700,
  },
  company: {
    color: "#0096ff",
  },
  description: {
    fontSize: "14px",
    color: "#4a494b",
    marginTop: "25px",
    fontWeight: 400,
    "@media (max-width: 370px)": {
      fontSize: "12px",
    },
  },
  imageIcon: {
    objectFit: "cover",
  },
};

export default styles;
